<script setup>
import { useStorage } from '@vueuse/core'
const tech = useTech()

const { toggleDarkMode } = useDarkMode()
const { isDarkMode } = storeToRefs(useDarkMode())
const darkMode = useStorage('darkMode')

const loading = ref(true)
const isDark = ref(false)

// Reactive modes array
const modes = computed(() => [
  {
    id: 'dark',
    icon: '/images/icon-dark.svg',
    label: 'Dark Mode',
    active: isDark.value
  },
  {
    id: 'light',
    icon: '/images/icon-light.svg',
    label: 'Light Mode',
    active: !isDark.value
  }
])

onMounted(() => {
  loading.value = false
  if (darkMode.value === 'true' || !darkMode.value) {
    isDark.value = true
  } else if (darkMode.value === 'false') {
    isDark.value = false
  }
})

function toggle () {
  toggleDarkMode()
  isDark.value = isDarkMode.value
}

const forceDarkModeToggle = inject('forceDarkModeToggle', false)
</script>

<template>
  <button
    v-if="tech.isDarkThemeEnabled || forceDarkModeToggle"
    :disabled="loading"
    class="m-4 inline-flex cursor-pointer select-none items-center gap-2 rounded-full bg-anti-flash p-2 text-black transition-transform duration-75 ease-linear disabled:opacity-50 md:m-0 hover:xl:scale-105 dark:bg-dark-gunmetal dark:text-white"
    @click.prevent="toggle">
    <div
      v-for="mode in modes"
      :key="mode.id"
      class="size-4">
      <InlineSvg
        :src="mode.icon"
        hard-code
        class="fill-current"
        :class="{ 'opacity-30': !mode.active, 'invisible': loading }" />
    </div>
  </button>
</template>
